import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';

import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, homepageUploadDir } from '../../../config';
import { formatLocale } from '../../../helpers/formatLocale';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './HomeSettingsForm.css';
import bt from '../../../components/commonStyle.css';

export class HomeSettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicHomeBannerTitle } = nextProps;
		let filteredLanguages = dynamicHomeBannerTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successBanner = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('homeSectionImage1', fileName);
		await updateTempImages('Homepage', 'homeSectionImage1', fileName);
	}

	successImage = async (fileName) => {
		const { change, updateTempImages } = this.props;
		await change('homeSectionImage2', fileName);
		await updateTempImages('Homepage', 'homeSectionImage2', fileName);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength, inputClassname }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group className={inputClassname}>
				{label && <label className={bt.labelText} >{label}</label>}
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} maxlength={maxlength} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}
	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<FormGroup className={s.formGroup}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
						>
							{children}
						</FormControl>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderFormControlSelect = ({ input, label, meta: { touched, error }, className, fieldIndex, children }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={"noMargin"}>
				{label && <label className={bt.labelText} >{label}</label>}
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderBannerTitle = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;
		return (
			<div className={bt.languageBox}>
				{
					fields && fields?.map((banner, index) => {
						let fieldLength = fields.length - 1;
						const currentLanguage = fields?.get(index)?.language;
						const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
						return (
							<div key={index}>
								<Row>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.mb12Xs}>
										<Field name={`${banner}.language`} component={this.renderFormControlSelect} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)} label={formatMessage(messages.language)}>
											<option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
											{
												availableLanguages?.map((locale, index) => {
													return (
														<option value={locale} key={index}>{formatLocale(locale)}</option>
													)
												})
											}
										</Field>
									</Col>
									<Col lg={6} md={6} sm={12} xs={12} className={bt.mb12Xs}>
										<Field name={`${banner}.value`} type="text" component={this.renderField} inputClassname={'noMargin'} label={formatMessage(messages.homeTitle)} />
									</Col>
								</Row>
								<div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
									{(fields.length <= languageList?.length - 1) && fieldLength == index &&
										<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")}>
											<img src={addIcon} alt='addIcon' />
											<span>	{formatMessage(messages.addLanguage)}</span>
										</Button>
									}
									{index != 0 && <div>
										<Button onClick={() => fields.remove(index)} className={cx(bt.languageBtn, 'textWhite', "btnBorderWhte")}>
											<img src={trashIcon} alt='addIcon' />
											<span>{formatMessage(messages.deleteLanguage)}</span>
										</Button>
									</div>}
								</div>
							</div>
						)
					})
				}
			</div>
		)
	}

	render() {
		const { handleSubmit, loading, submitting, homeSectionImage1, homeSectionImage2, homeImageLoader, homePageImageLoader, dynamicHomeBannerTitle } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<div className={s.responsiveNoPadding}>
					<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.homepageBanner)}</h1>
					<Card className={s.card}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<Row>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successBanner}
													loaderName={'homeImageLoader'}
													loader={homeImageLoader}
													fieldName={'homeSectionImage1'}
													formName={'HomeSettingsForm'}
													imageSrc={homeSectionImage1 ? api.apiEndpoint + homepageUploadDir + 'medium_' + homeSectionImage1 : null}
													label={formatMessage(messages.homeImage1)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={api.apiEndpoint + '/uploadHomepageImage'}
													handleDropzone={this.successImage}
													loaderName={'homePageImageLoader'}
													loader={homePageImageLoader}
													fieldName={'homeSectionImage2'}
													formName={'HomeSettingsForm'}
													imageSrc={homeSectionImage2 ? api.apiEndpoint + homepageUploadDir + 'medium_' + homeSectionImage2 : null}
													label={formatMessage(messages.homeImage2)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col lg={12} md={12} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'noMargin')}>
										<div>
											<FieldArray name='homeSectionTitle1' rerenderOnEveryChange={true} component={this.renderBannerTitle} dynamicHomeBannerTitle={dynamicHomeBannerTitle} />
										</div>
									</Form.Group>
								</Col>
							</Row>
							<div className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
								<Form.Group className={s.formGroup}>
									<div className={s.displayInlineBlock}>
										<Loader
											type={"button"}
											label={formatMessage(messages.submitButton)}
											show={loading}
											buttonType={'submit'}
											className={cx(bt.btnPrimary, bt.clickBtn)}
											disabled={submitting || loading}
											isSuffix={true}
										/>
									</div>
								</Form.Group>
							</div>
						</Form>
					</Card>
				</div>
			</div>
		)
	}
}

HomeSettingsForm = reduxForm({
	form: 'HomeSettingsForm',
	onSubmit: submit,
	validate
})(HomeSettingsForm);

const selector = formValueSelector('HomeSettingsForm')

const mapState = (state) => ({
	homeSectionImage1: selector(state, 'homeSectionImage1'),
	homeSectionImage2: selector(state, 'homeSectionImage2'),
	homeSectionImage3: selector(state, 'homeSectionImage3'),
	homeSectionImage4: selector(state, 'homeSectionImage4'),
	homeSectionImage5: selector(state, 'homeSectionImage5'),
	homeSectionImage6: selector(state, 'homeSectionImage6'),
	homeSectionImage7: selector(state, 'homeSectionImage7'),
	homeSectionImage8: selector(state, 'homeSectionImage8'),
	loading: state?.loader?.HomeSettingsForm,
	homeImageLoader: state?.loader?.homeImageLoader,
	homePageImageLoader: state?.loader?.homePageImageLoader,
	languageList: state?.runtime?.availableLocales,
	dynamicHomeBannerTitle: selector(state, 'homeSectionTitle1'),
})

const mapDispatch = {
	change,
	updateTempImages
}

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(HomeSettingsForm)));
